import httpClient from "Api/httpClient";

const END_POINT = "/inventory_receipts";

const getInventoryReceipts = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getInventoryReceipt = (receipt_id) => {
    if (!receipt_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + receipt_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printInventoryReceipt = (receipt_id) => {
    if (!receipt_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?receipt_id=" + receipt_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createInventoryReceipts = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateInventoryReceipts = (payload, receipt_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + receipt_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteInventoryReceipts = (receipt_id) => {
    const DELETE_END_POINT = END_POINT + "/" + receipt_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getInventoryReceipts, getInventoryReceipt, printInventoryReceipt, createInventoryReceipts, updateInventoryReceipts, deleteInventoryReceipts };
